var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      staticClass: "flex items-center",
      attrs: {
        title: _vm.title,
        variant: _vm.variant,
        disabled: !_vm.showTooltip,
        tooltipClasses: _vm.tooltipClasses,
        placement: _vm.tooltipPlacement,
        maxWidth: _vm.tooltipWidth,
      },
    },
    [
      _vm.route
        ? _c(
            "RouterLink",
            {
              staticClass: "block",
              class: _vm.customClass,
              attrs: { to: _vm.routeTo },
            },
            [
              _c(
                "div",
                {
                  staticClass: "rounded-full overflow-hidden bg-gray-100",
                  class: _vm.circleSizeClasses,
                },
                [
                  _vm.avatar
                    ? _c(
                        "div",
                        [
                          _c("S3Image", {
                            staticClass: "chipHeight circleWidth rounded-full",
                            attrs: { s3FileKey: _vm.avatar },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "inline-flex items-center justify-center h-8 w-8 rounded-full",
                          style: _vm.bgStyle,
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-white font-bold",
                              class: _vm.textSizeClasses,
                            },
                            [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                          ),
                        ]
                      ),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "rounded-full overflow-hidden",
              class: [_vm.circleSizeClasses, _vm.customClass, _vm.cursor],
            },
            [
              _vm.avatar
                ? _c(
                    "div",
                    [
                      _c("S3Image", {
                        staticClass: "chipHeight circleWidth rounded-full",
                        attrs: { s3FileKey: _vm.avatar },
                      }),
                    ],
                    1
                  )
                : _c(
                    "span",
                    {
                      staticClass:
                        "inline-flex items-center justify-center rounded-full",
                      class: _vm.circleSizeClasses,
                      style: _vm.bgStyle,
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "leading-none text-white font-bold",
                          class: _vm.textSizeClasses,
                          attrs: { id: "circleInitial" },
                        },
                        [
                          _c(_vm.defaultImageComponentName, {
                            tag: "component",
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }